module.exports = class BulkTransfersListCtrl
  $onInit: ->
    @updateTable = @updateTable.bind(@)

  updateTable: ->
    @onRefresh()
